import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

function authHeaders() {
  const token = null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function downloadStaffImportTemplate() {
  const res = await axios.get(`${API}/staffs/import/template`, {
    headers: authHeaders(),
    responseType: "blob",
  });
  return res.data;
}

export async function createStaffImportJob({ file, salon_id }) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("salon_id", salon_id);
  const res = await axios.post(`${API}/staffs/import/jobs`, formData, {
    headers: {
      ...authHeaders(),
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function previewStaffImportJob(jobId, payload) {
  const res = await axios.post(`${API}/staffs/import/jobs/${jobId}/preview`, payload, {
    headers: {
      ...authHeaders(),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function commitStaffImportJob(jobId, payload) {
  const res = await axios.post(`${API}/staffs/import/jobs/${jobId}/commit`, payload, {
    headers: {
      ...authHeaders(),
      "Content-Type": "application/json",
    },
  });
  return res.data;
}

export async function listStaffImportJobs({ salon_id, page = 1, per_page = 10 }) {
  const res = await axios.get(`${API}/staffs/import/jobs`, {
    params: { salon_id, page, per_page },
    headers: authHeaders(),
  });
  return res.data;
}

export async function getStaffImportJob(jobId) {
  const res = await axios.get(`${API}/staffs/import/jobs/${jobId}`, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function rollbackStaffImportJob(jobId) {
  const res = await axios.post(
    `${API}/staffs/import/jobs/${jobId}/rollback`,
    {},
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}
